import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { TRIGGER_CHART_TYPES } from '/src/features/goals/constants';
import { SPECIAL_DATE_RANGES } from '../_global/constants';

export const goalSelectedDatesAtom = atomWithDefault(() => {
  const params = new URLSearchParams(window.location.search);
  const dateRange = params.get('date_range') || SPECIAL_DATE_RANGES.LAST_7_DAYS;

  if (dateRange.includes(',')) {
    const [startDate, endDate] = dateRange.split(',').map(Number);
    return {
      special: null,
      startDate,
      endDate,
    };
  } else if (dateRange.length) {
    return {
      special: dateRange,
      startDate: null,
      endDate: null,
    };
  } else {
    return {
      special: SPECIAL_DATE_RANGES.LAST_7_DAYS,
      startDate: null,
      endDate: null,
    };
  }
});

export const goalDetailSelectedTriggerType = atom(TRIGGER_CHART_TYPES.SEPARATE);
